import React, { memo } from "react";
import { HalfCard } from "@swiggy-private/dls-web-core/dist/components/HalfCard";

import BillPaymentContent from "./BillPaymentContent";
import { IBillPaymentConfirmationProps } from "./types";

const BillPaymentConfirmation = memo(
    ({ show, onHide, onSecondaryClick, onPrimaryClick }: IBillPaymentConfirmationProps) => {
        return (
            <HalfCard isOpen={show} onClose={onHide}>
                <BillPaymentContent
                    onSecondaryAction={onSecondaryClick}
                    onPrimaryAction={onPrimaryClick}
                />
            </HalfCard>
        );
    }
);

BillPaymentConfirmation.displayName = "BillPaymentConfirmation";

export default BillPaymentConfirmation;
